var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout"},[_c('LayoutHeader'),_c('Content',[_c('Sidebar',{attrs:{"slot":"left"},slot:"left"}),_c('router-view',{key:_vm.key,attrs:{"slot":"content"},slot:"content"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }